export const IOS = "ios";
export const ANDROID = "android";
export const WEB = "web";
